
<v-dialog
    v-model    = "show"
    transition = "dialog-bottom-transition"
    fullscreen
    hide-overlay
    persistent
    no-click-animation
    v-resize="onResize"
>
    <div class="white" style="margin-top: 6px;height: calc(100% - 15px); width: calc(100% - 75px); ">
        <f-dialog-title
            title   = "OUTBOX"
            @cancel = "onClose"
            style="border-radius: 4px;margin-left: 75px; "
        >
        </f-dialog-title>

        <div class="w-100 mt-1" style="margin-left: 75px;">
            <p-inc-outbox
                :height = "height"
                @close  = "onClose"
            />
        </div>
    </div>
</v-dialog>
